module.exports = __webpack_public_path__ + "img/ph.abde0f3f.png";